<div class="card card-custom rounded-0 vh-100">
  <div class="card-header">
    <div class="card-title">
      <img
        [src]="
          resource.type === ResourceType.HTML
            ? './assets/media/svg/files/html.svg'
            : resource.type === ResourceType.PDF
            ? './assets/media/svg/files/pdf.svg'
            : './assets/media/svg/files/mp4.svg'
        "
        alt="Filetype Icon"
        width="30px"
        class="mr-2"
      />
      <h3 class="card-label">
        {{ resource.type === ResourceType.VIDEO_LINK ? 'VIDEO' : resource.type }} Resource
      </h3>
    </div>
    <div class="card-toolbar">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="close($event)">
        <i class="flaticon2-cross icon-sm p-0"></i>
      </button>
    </div>
  </div>
  <div style="max-height: fit-content" class="card-body overflow-hidden flex-grow-1">
    <iframe
      *ngIf="resource.type !== ResourceType.PDF"
      width="100%"
      height="100%"
      class="border-0 rounded"
      allowfullscreen
      [src]="src | safe : 'resourceUrl'"
    ></iframe>
    <ngx-extended-pdf-viewer
      *ngIf="resource.type === ResourceType.PDF"
      height="100%"
      [src]="src"
      [useBrowserLocale]="true"
    ></ngx-extended-pdf-viewer>
  </div>
</div>
